import { LynxWhiteboardLogo } from '@lynx/client-core/src/components'
import i18next from 'i18next'
import React from 'react'
import css from './Ended.module.scss'

interface EndedProps {
	ended: boolean
}

export const Ended = ({ ended }: EndedProps): React.ReactElement | null => {
	if (!ended) return null

	return (
		<div className={css['container']}>
			<div className={css['container__content']}>
				<LynxWhiteboardLogo />
				<p>{i18next.t('pages.litb.sessionEnded')}</p>
				<p className={css['featurePreview']}>{i18next.t('pages.litb.featurePreview')}</p>
			</div>
		</div>
	)
}
